import React, { createContext, useState, useEffect } from 'react';
import firebase from '../config';
import swal from 'sweetalert';

// Create the AuthContext
export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);
  const [loading, setLoading] = useState(true); // Initial loading state

  useEffect(() => {
    // Display a loading message when checking session status
    swal({
      title: 'Loading...',
      text: 'Checking your session.',
      icon: 'info',
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
    });

    // Firebase auth state listener to check user authentication
    const unsubscribe = firebase.auth().onAuthStateChanged((user) => {
      setCurrentUser(user);
      setLoading(false); // Once Firebase resolves, set loading to false
      swal.close(); // Close loading dialog once session is resolved
    });

    // Cleanup subscription when the component unmounts
    return () => unsubscribe();
  }, []);

  // Logout function to sign out the user
  const logout = () => {
    firebase.auth().signOut()
      .then(() => {
        setCurrentUser(null); // Reset the currentUser in state
        localStorage.clear(); // Clear local storage for security
        sessionStorage.clear(); // Clear session storage as well
        swal("Logged Out", "You have been logged out successfully.", "success")
          .then(() => {
            window.location.href = '/admin'; // Redirect to admin login page
          });
      })
      .catch((error) => { swal("Logout Failed", "An error occurred during logout. Please try again.", "error"); });
  };

//   const logErrorToFirebase = (logMessage) => {
//     const logRef = firebase.database().ref('logs');
//     const logEntry = {
//         message: logMessage,
//         timestamp: Date.now()
//     };
//     logRef.push(logEntry);
// };

  // Provide the currentUser, loading, and logout function to children
  return (
    <AuthContext.Provider value={{ currentUser, loading, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
